import { Component, OnDestroy, Inject } from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {DialogPopupInteface} from "../../../core/interfaces/dialog-popup.interface";



@Component({
  selector: 'app-requalification-dialog',
  imports: [],
  templateUrl: './requalification-dialog.component.html',
  styleUrl: './requalification-dialog.component.scss'
})
export class RequalificationDialogComponent implements OnDestroy {
  private ngUnsubscribe$ = new Subject<void>();

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogPopupInteface,
              public dialog: MatDialog,
  ) {
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  protected onClick(image_alt: string) {
    if (this.data.link != null) {
      window.open(this.data.link, this.data.target);
    }
    this.dialog.closeAll();
  }
}
